import React from "react";
import Layout from "components/Layout";
import HomeForm from "./components/HomeForm";

function Home() {
  return (
    <Layout title={`현장 관제 v${process.env.REACT_APP_VERSION}`}>
      <HomeForm />
    </Layout>
  );
}

export default Home;
